var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100 h-100"},[_c('canvas',{ref:'networkStatisticsChart' + _vm.id,attrs:{"id":'networkStatisticsChart' + _vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }